(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection__toplevel-great-for"]) return;
  try {
    

$(document).ready(function () {
  $('.great-for__slideshow').slick({
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></button>',  
    autoplay: true,
    autoplaySpeed: 6000,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
      responsive: [
          {
              breakpoint: 1200,
              settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
              }
          },
          {
            breakpoint: 980,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
          },
          {
              breakpoint: 480,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
              }
          }
      ]
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection__toplevel-testimonials"]) return;
  try {
    

$(document).ready(function () {
  $(".testimonials__slideshow").slick({
    autoplay: true,
    autoplaySpeed: 6000, 
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></button>'
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-great-for"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
  $('.great-for__slideshow').slick({
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></button>',  
    autoplay: true,
    autoplaySpeed: 6000,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
      responsive: [
          {
              breakpoint: 1200,
              settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
              }
          },
          {
            breakpoint: 980,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
          },
          {
              breakpoint: 480,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
              }
          }
      ]
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-products"] && !Shopify.designMode) return;
  try {
    
$('.tabs span').click(function(){
  let activeProduct = $(this).data('product');
  $('.product-data').each(function(){
    $(this).data('product') == activeProduct ? $(this).addClass('active') : $(this).removeClass('active');
  })
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-testimonials"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
  $(".testimonials__slideshow").slick({
    autoplay: true,
    autoplaySpeed: 6000, 
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></button>'
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
  $('.question').click(function() {
    $(this)
      .toggleClass('active')
      .next()
      .slideToggle();
 
    if ($(this).hasClass('active')) {
      $(this).find('span').text('-')
    } else {
      $(this).find('span').text('+')
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"]) return;
  try {
    
  $('.accordion-heading').click(function() {
    $(this)
      .toggleClass('active')
      .next()
      .slideToggle();
 
    if ($(this).hasClass('active')) {
      $(this).find('span').text('-')
    } else {
      $(this).find('span').text('+')
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testimonials-cooling"]) return;
  try {
    

$(document).ready(function () {
  $(".testimonials__slideshow").slick({
    autoplay: true,
    autoplaySpeed: 6000,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></button>'
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testimonials-cotton"]) return;
  try {
    

$(document).ready(function () {
  $(".testimonials__slideshow").slick({
    autoplay: true,
    autoplaySpeed: 6000,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></button>'
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testimonials-original"]) return;
  try {
    

$(document).ready(function () {
  $(".testimonials__slideshow").slick({
    autoplay: true,
    autoplaySpeed: 6000,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></button>'
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testimonials-staple"]) return;
  try {
    

$(document).ready(function () {
  $(".testimonials__slideshow").slick({
    autoplay: true,
    autoplaySpeed: 6000,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></button>'
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testimonials"]) return;
  try {
    

$(document).ready(function () {
  $(".testimonials__slideshow").slick({
    autoplay: true,
    autoplaySpeed: 6000,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></button>'
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  $(document).ready(function() {
    if ($('input:checked').val() == 'Denim Blue'){
      $('.bundle-text__denim-blue').removeClass('hidden');
    }
    $("input[type=radio]").change(function() {
      if ($('input:checked').val() == 'Denim Blue'){
        $('.bundle-text__denim-blue').removeClass('hidden');
      } else {
        $('.bundle-text__denim-blue').addClass('hidden');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
